import futura from '../assets/futura.png'
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import close from '../assets/close.png'
import arrow from '../assets/arrow2.png'
function N6({ bookid, nextPage, previuosPage, home }) {
    //const history = useHistory()

    //const { bookid } = useParams()
    const [pres, setPres] = useState()
    const [address, setAddress] = useState()
    const [addressNote, setAddressNote] = useState()
    //const [when, setWhen] = useState()
    const [rate, setRate] = useState()
    const [pref, setPref] = useState()
    const [city, setCity] = useState()
    const [door, setDoor] = useState()


    const getBook = () => {
        fetch(document.apiURL + '/book/' + bookid, {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                if (response[0].hasOwnProperty("treatment")) {
                    if (response[0].treatment !== null && response[0].treatment.hasOwnProperty("treatment")) {
                        setPres(response[0].treatment.treatment)
                    } else {
                        setPres(response[0].treatment)
                    }
                } else {
                    setPres("Nulla")
                }

                setAddress(response[0].address)
                setDoor(response[0].dorbell_name)
                //setWhen(response[0].start_treat)
                setCity(response[0].city.city)
                setPref(response[0].booking_time)
                setAddressNote(response[0].address_note)

                if (response[0].hasOwnProperty("treatment")) {
                    if (response[0].treatment !== null && response[0].treatment.hasOwnProperty("rate")) {
                        setRate(response[0].treatment.rate)
                    } else {
                        setRate("Nulla")
                    }
                } else {
                    setRate("Nulla")
                }
            });
    }

    useEffect(() => {
        getBook();
    }, []);

    return (<>
        <div className="back-profilazione" style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="square-center">
            <div className="flex row sp" style={{ borderRadius: '16px 16px 0px 0px' }}>

<img src={arrow} onClick={()=> previuosPage()} /> 
<img src={close} onClick={()=> home()} />  

</div>
                <div className="flex row center-con sp">
                    <h2 className="c">Riepilogo dell'intervento</h2><img src={futura} className="min-fut">
                    </img>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Tipo di prestazione</h4>
                        <p>{pres}</p>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Dove</h4>
                        <div style={{ display: 'flex', width: '100%' }}>
                            <p> {city},</p><p>{address},</p><p>{addressNote} </p> <p>{door}</p></div>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Quando</h4>

                        <p> Preferenza oraria: {pref}</p>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Totale</h4>
                        <p>{rate}</p>

                    </div>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>

                        <button className="button margin-top-min" style={{ marginTop: '20px', width: '50%', alignSelf: 'center' }} onClick={() => nextPage()}>Continua</button>

                    </div>
                </div>




            </div>
            <p style={{ marginTop: '40px', fontWeight: 300, marginBottom: '40px', textAlign: 'center' }}>In caso di necessit&agrave; puoi contattare un nostro operatore al numero<br /> <a href='tel:+3908119312726'>081 193 12 726</a> che ti aiutera nella prenotazione.</p>

        </div>
    </>
    );
}

export default N6;